import useFilters from '../../../hook/useFilters'
import {runSpecificTask} from '../services'
import {useEffect, useState} from 'react'
import useToastify from '../../../hook/useToastify'
import useApi from '../../../services/useApi'

function useGetJobData(job_id: string) {
  const Api = useApi()
  const [isProcessing, setIsProcessing] = useState(false)
  const {toastMessage} = useToastify()
  const initialFilters = {
    job_id: job_id,
  }
  const {filters} = useFilters(initialFilters)

  const {
    data: response,
    refetch,
    isLoading,
  } = Api.useGetQuery(`/settings/job`, {
    filters: filters,
    queryId: `get-job-data`,
    isToast: false,
    isErrorPageRedirection: false,
  })

  const runTask = async (name?: string) => {
    setIsProcessing(true)
    const res = await runSpecificTask(name ? name : job_id)
    if (res?.['id']) {
      refetch()
      toastMessage('success', 'Task Scheduled Successfully.')
      setIsProcessing(false)
    }
  }

  useEffect(() => {
    let intervalId: any = null
    if (response?.data?.status === 'running') {
      intervalId = setInterval(() => {
        refetch()
      }, 30000)
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response?.data?.status === 'running', refetch])

  // Return only icon info as plain data, not React elements or objects
  const labelIconClass =
    response?.data?.status === 'running'
      ? 'fas fa-refresh fa-spin fs-5 p-1 me-1'
      : 'fas fa-sync cursor-pointer fs-5 me-2'

  return {
    jobData: response?.data || [],
    isLoading: isLoading,
    isRunning: response?.data?.status === 'running',
    labelIconClass,
    label: response?.data?.status === 'running' ? 'Syncing...' : 'Sync Data',
    runTask,
    isProcessing,
    refetchJobData: refetch,
  }
}

export default useGetJobData
